import { css } from '@emotion/react';
import { HEIGHT_MAX, WIDTH_MAX } from '@pages/Main/MainView/constants';

export const bannerContainer = css({
  height: 637
});

export const videoWrapper = css({
  width: WIDTH_MAX,
  height: HEIGHT_MAX,
  objectFit: 'cover',
  position: 'fixed',
  top: 0,
  left: 0,
  zIndex: -2
});
